var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex items-center justify-center h-screen w-screen"},[_c('div',{staticClass:"text-center text-grey-650"},[_vm._m(0),_vm._t("default",function(){return [_c('router-view')]})],2)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mb-6 flex justify-center"},[_c('img',{staticClass:"h-8",attrs:{"src":require("../assets/img/logo_activix_crm_gray.png"),"alt":"Activix CRM"}})])
}]

export { render, staticRenderFns }